import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=c4c7e7ce&"
import script from "./forgot.vue?vue&type=script&lang=ts&"
export * from "./forgot.vue?vue&type=script&lang=ts&"
import style0 from "./forgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports